import { useState } from "react";
import { useTranslation } from "react-i18next";
import Navbar from "@/pages/home/components/Navbar";
import LegalDocument, { type LegalSection } from "@/components/feature/LegalDocument";
import QuoteModal from "@/components/feature/QuoteModal";
import WhatsAppFloat from "@/components/feature/WhatsAppFloat";
import LandingFooter from "@/components/feature/LandingFooter";
import LanguageTransitionWrapper from "@/components/feature/LanguageTransitionWrapper";

const privacySections: LegalSection[] = [
  { id: "responsable", titleKey: "legal.privacy.s1.title", bodyKeys: ["legal.privacy.s1.p1", "legal.privacy.s1.p2"] },
  { id: "datos", titleKey: "legal.privacy.s2.title", bodyKeys: ["legal.privacy.s2.p1", "legal.privacy.s2.p2"] },
  { id: "finalidad", titleKey: "legal.privacy.s3.title", bodyKeys: ["legal.privacy.s3.p1", "legal.privacy.s3.p2"] },
  { id: "base-legal", titleKey: "legal.privacy.s4.title", bodyKeys: ["legal.privacy.s4.p1"] },
  { id: "conservacion", titleKey: "legal.privacy.s5.title", bodyKeys: ["legal.privacy.s5.p1"] },
  { id: "cookies", titleKey: "legal.privacy.s6.title", bodyKeys: ["legal.privacy.s6.p1", "legal.privacy.s6.p2"] },
  { id: "comunicacion", titleKey: "legal.privacy.s7.title", bodyKeys: ["legal.privacy.s7.p1", "legal.privacy.s7.p2"] },
  { id: "derechos-arco", titleKey: "legal.privacy.s8.title", bodyKeys: ["legal.privacy.s8.p1", "legal.privacy.s8.p2"] },
  { id: "seguridad", titleKey: "legal.privacy.s9.title", bodyKeys: ["legal.privacy.s9.p1", "legal.privacy.s9.p2"] },
  { id: "cambios", titleKey: "legal.privacy.s10.title", bodyKeys: ["legal.privacy.s10.p1"] },
];

export default function PoliticaPrivacidadPage() {
  const { t } = useTranslation("common");
  const [quoteOpen, setQuoteOpen] = useState(false);
  const [quoteService, setQuoteService] = useState<string | undefined>(undefined);

  const openQuote = (service?: string) => {
    setQuoteService(service);
    setQuoteOpen(true);
  };
  const closeQuote = () => {
    setQuoteOpen(false);
    setTimeout(() => setQuoteService(undefined), 300);
  };

  return (
    <div className="relative bg-background-950 min-h-screen">
      <Navbar onOpenQuote={openQuote} />

      <LanguageTransitionWrapper>
        <LegalDocument
          titleKey="legal.privacy.title"
          subtitleKey="legal.privacy.subtitle"
          updatedKey="legal.privacy.updated"
          sections={privacySections}
          documentTitle="Política de Privacidad | Openlab Secure"
          seeAlso={[{ to: "/terminos", labelKey: "legal.link.terms", icon: "ri-file-text-line" }]}
        />

        <LandingFooter pageName={t("legal.link.privacy")} />
      </LanguageTransitionWrapper>

      <QuoteModal isOpen={quoteOpen} onClose={closeQuote} preselectedService={quoteService} />
      <WhatsAppFloat />
    </div>
  );
}